import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AssetProvider } from "./context/AssetContext";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import AssetsPage from "./pages/AssetsPage";
import AssetFormPage from "./pages/AssetFormPage";
import AssetDetailPage from "./pages/AssetDetailPage";
import AssetTypesPage from "./pages/AssetTypesPage";
import AssetTypeForm from "./pages/AssetTypeForm";
import AssetTypeBulkUploadPage from "./pages/AssetTypeBulkUploadPage";
import PropertiesPage from "./pages/PropertiesPage";
import BranchesPage from "./pages/BranchesPage";
import "./styles/App.css";

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Save the attempted URL for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AssetProvider>
          <div className="app">
            <Navigation />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/assets"
                  element={
                    <ProtectedRoute>
                      <AssetsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/assets/create"
                  element={
                    <ProtectedRoute>
                      <AssetFormPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/assets/:id" element={<AssetDetailPage />} />
                <Route path="/:assetCode" element={<AssetDetailPage />} />
                <Route
                  path="/assets/:id/edit"
                  element={
                    <ProtectedRoute>
                      <AssetFormPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/asset-types"
                  element={
                    <ProtectedRoute>
                      <AssetTypesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/properties"
                  element={
                    <ProtectedRoute>
                      <PropertiesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/branches"
                  element={
                    <ProtectedRoute>
                      <BranchesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/asset-types/create"
                  element={
                    <ProtectedRoute>
                      <AssetTypeForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/asset-types/upload"
                  element={
                    <ProtectedRoute>
                      <AssetTypeBulkUploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/asset-types/:id/edit"
                  element={
                    <ProtectedRoute>
                      <AssetTypeForm />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </main>
          </div>
        </AssetProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
